// extracted by mini-css-extract-plugin
export default {"send-button":"SuggestionForm_send-button__eODom","reset-button":"SuggestionForm_reset-button__Uel8L"};